import { render } from "./Plantmoxing.vue?vue&type=template&id=8ade30f0&scoped=true"
import script from "./Plantmoxing.vue?vue&type=script&lang=js"
export * from "./Plantmoxing.vue?vue&type=script&lang=js"

import "./Plantmoxing.vue?vue&type=style&index=0&id=8ade30f0&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-8ade30f0"

export default script